module.exports = __webpack_public_path__ + "static/media/logo.cec4f646.png";